var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.visible,
            width: "1000px",
            "append-to-body": "",
            "close-on-click-modal": false,
            "before-close": _vm.toCancel,
            no: "1"
          },
          on: {
            "update:visible": function($event) {
              _vm.visible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "text1", attrs: { no: "2" } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.ScopeServices")))
          ]),
          _c("div", { staticClass: "h-px", attrs: { no: "3" } }),
          _c("div", { staticClass: "title", attrs: { no: "4" } }, [
            _vm._v(
              _vm._s(
                _vm.$t("OperationGuide.Title1") +
                  _vm.vgmCarriers.length +
                  _vm.$t("OperationGuide.Title2")
              )
            )
          ]),
          _c("div", { staticClass: "service-scope", attrs: { no: "5" } }, [
            _c(
              "div",
              { staticClass: "el-tabs__nav", attrs: { no: "6" } },
              _vm._l(_vm.ports, function(port) {
                return _c(
                  "div",
                  {
                    key: port.name,
                    class: [
                      "el-tabs__item",
                      { active: _vm.activeTab === port.name }
                    ],
                    attrs: { no: "7" },
                    on: {
                      click: function($event) {
                        return _vm.onClickTab(port.name)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(port.name) + " ")]
                )
              }),
              0
            ),
            _c(
              "div",
              _vm._l(_vm.showVgmCarriers, function(company) {
                return _c(
                  "button",
                  {
                    key: company.name,
                    staticClass: "button",
                    attrs: { no: "8" }
                  },
                  [_vm._v(" " + _vm._s(company.name) + " ")]
                )
              }),
              0
            )
          ]),
          _c(
            "span",
            {
              staticStyle: { padding: "10px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { no: "toCancel" }, on: { click: _vm.toCancel } },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Close")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }